// Generated by CoffeeScript 1.12.2
let Change_Avatar;

Change_Avatar = (() => {
  function Change_Avatar() {
    let saveAvatar = function() {
      let $button;
      let $fakeFile;
      let $filename;
      let $this;
      let $val;
      let newVal;
      let valArray;
      $this = $("input#choose-input");
      $val = $this.val();
      valArray = $val.split("\\");
      newVal = valArray[valArray.length - 1];
      $button = $(".button-container");
      $filename = $(".filename");
      $fakeFile = $this.siblings(".file-holder");
      if (newVal !== "") {
        if ($fakeFile.length === 0) {
          $filename.html(`<span class="file-holder">File: ${newVal}</span>`);
        } else {
          $fakeFile.text(newVal);
        }
        $("button.ui_save.hidden").removeClass("hidden");
        $("button.file-wrapper").hide();
        return $(".file-wrapper .button, .file-wrapper #choose-input").addClass(
          "hidden",
        );
      }
      $(".button.file-wrapper.ui_upload").addClass("hidden");
      $(".file-wrapper input[type=file]").on(
        "change focus click",
        saveAvatar,
      );
    };
    $(".button.file-wrapper.ui_upload").on("click", function(e) {
      saveAvatar();
    });
    $("#save-avatar").on("click", function(e) {
      return $(this).addClass("processing");
    });
  }

  return Change_Avatar;
})();

export default Change_Avatar;
